import { globalState } from '@codeleap/store'

export const cursorStore = globalState({ nextCursor: null, previousCursor: null })
export const tmpVideoStore = globalState<Record<string, string>>({})
export const filtersStore = globalState({})
